import React, { Component } from 'react';
import { Modal, Button, message, Input } from 'antd';
import { revokeApply } from "@/request/api";
import './remoteConsulation.scss';

const { TextArea } = Input;
class RevokeConsultant extends Component {
      state = {
            revokeReasonVal: '',
            revokeResultVal: ''
      }

      handleSubmitRevoke = (isRevoke) => {
            const { revokeReasonVal, revokeResultVal } = this.state
            const { rowData, showKey } = this.props
            if (parseInt(showKey) >= 4) {
                  var REVOKE_REASON = revokeReasonVal //撤销原因
            } else if (revokeResultVal) {
                  REVOKE_REASON = revokeResultVal //撤销结果
            } else { //撤销结果不写则填入按钮文字
                  REVOKE_REASON = isRevoke === 1 ? '同意' : '拒绝'
            }
            let params = {
                  Type: parseInt(showKey) >= 4 ? 'APPLY_REVOKE' : 'IS_AGREE_REVOKE',
                  EXAM_UID: rowData.EXAM_UID,
                  REVOKE_REASON: REVOKE_REASON,
                  IS_REVOKE: isRevoke//是否同意：0拒绝；1同意
            }
            revokeApply(params).then((res) => {
                  if (res && res.Status === 1) {
                        this.props.onRef(false);
                        this.props.refreshTable()
                  } else {
                        message.error("撤销会诊失败")
                  }
            })
      }


      handleCloseRevokeModal = () => {
            this.props.onRef(false);
      }

      revokeReason = (e) => {
            this.setState({
                  revokeReasonVal: e.target.value
            })
      }
      revokeResult = (e) => {
            this.setState({
                  revokeResultVal: e.target.value
            })
      }

      render() {
            const { visible, showKey, rowData } = this.props
            return (
                  <Modal
                        className="consulationH"
                        width={440}
                        title="撤销会诊申请"
                        visible={visible}
                        footer={[
                              <Button key='save' type="primary" onClick={() => this.handleSubmitRevoke(1)}>
                                    {parseInt(showKey) >= 4 ? '申请' : '同意'}
                              </Button>,
                              (
                                    parseInt(showKey) >= 4 ?
                                          < Button key='close' type="primary" onClick={this.handleCloseRevokeModal} >
                                                取消
                                          </Button > :
                                          <Button key='close' className='dangerBtn' type='danger' onClick={() => this.handleSubmitRevoke(0)}>
                                                拒绝
                                          </Button>
                              )
                        ]}
                        onCancel={this.handleCloseRevokeModal}  // 右上角的关闭按钮
                  >
                        <div className='revpkeTextArea'>
                              <span className="conName">撤销原因:</span>
                              <TextArea
                                    rows={4}
                                    maxLength={100}
                                    placeholder="请输入撤销原因，限制100字内"
                                    defaultValue={rowData.REVOKE_REASON}
                                    disabled={parseInt(showKey) < 4 ? true : false} onChange={this.revokeReason} />

                        </div>
                        {
                              parseInt(showKey) < 4 ?
                                    <div className='revpkeTextArea'>
                                          <span className="conName">反馈结果: </span>
                                          <TextArea rows={4} maxLength={100} placeholder="请输入反馈结果，限制100字内" onChange={this.revokeResult} />
                                    </div> : null
                        }
                  </Modal>
            )
      }
}

export default RevokeConsultant;